import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03d14766"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { class: "description" }
const _hoisted_6 = {
  key: 0,
  class: "control"
}

import { onMounted, ref, onBeforeMount } from 'vue'
import { icons } from '@/plugins/icon'


export default /*#__PURE__*/_defineComponent({
  __name: 'Message',
  props: {
    id: {},
    message: {},
    type: { default: 'success' },
    title: { default: '' },
    duration: { default: 3000 },
    closable: { type: Boolean, default: false }
  },
  emits: ["close", "destroy"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const {
  IconAttention,
  IconCheckOne,
  IconCloseOne,
  IconInfo,
  IconCloseSmall,
} = icons

const props = __props

const emit = __emit

const visible = ref(true)
const timer = ref<number | null>(null)

const startTimer = () => {
  if (props.duration <= 0) return
  timer.value = setTimeout(close, props.duration)
}
const clearTimer = () => {
  if (timer.value) clearTimeout(timer.value)
}

const close = () => visible.value = false

onBeforeMount(() => {
  clearTimer()
})
onMounted(() => {
  startTimer()
})

__expose({
  close,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "message-fade",
    appear: "",
    mode: "in-out",
    onBeforeLeave: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
    onAfterLeave: _cache[4] || (_cache[4] = ($event: any) => (emit('destroy')))
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "message",
            id: _ctx.id
          }, [
            _createElementVNode("div", {
              class: "message-container",
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (clearTimer())),
              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (startTimer()))
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.type === 'warning')
                  ? (_openBlock(), _createBlock(_unref(IconAttention), {
                      key: 0,
                      theme: "filled",
                      size: "18",
                      fill: "#faad14"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === 'success')
                  ? (_openBlock(), _createBlock(_unref(IconCheckOne), {
                      key: 1,
                      theme: "filled",
                      size: "18",
                      fill: "#52c41a"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === 'error')
                  ? (_openBlock(), _createBlock(_unref(IconCloseOne), {
                      key: 2,
                      theme: "filled",
                      size: "18",
                      fill: "#ff4d4f"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type === 'info')
                  ? (_openBlock(), _createBlock(_unref(IconInfo), {
                      key: 3,
                      theme: "filled",
                      size: "18",
                      fill: "#1677ff"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.title), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.message), 1)
              ]),
              (_ctx.closable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: "close-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
                    }, [
                      _createVNode(_unref(IconCloseSmall))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ], 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})